/**
 * MultiIssue — 사용자PC(/u/orders) 오더 상세팝업의 세금계산서 다중발행(묶음발행) 모달.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 다중발행 전역함수 18개를 이관했다(세금/다중발행 코어 슬라이스 B — 최종).
 *   진입:   multiDocumentListGet(발행상태=다중 선택 시 목록 로드) · multi_sel_list_do(선택목록 재조회)
 *   렌더:   renderMultiBillHead/renderMultiBillBody(화면표) · renderMultiSelRows(선택목록) · _multiStx1(발행상태 라벨)
 *   선택:   multi_selorderboxset(헤더 일괄체크) · checkMultiChallnot(전체체크) · popmultisel_checkCheck(합계) ·
 *           popmultisel_checkCheck_new/_paystatus_new(저장용 선택수집)
 *   추가:   multiSelMore · add_multipleOrder · make_Array_multiPleMore · getMultiMoreList · multiTaxclose
 *   초기화: reset_multiAll_billset_new
 *   유틸:   IntvalGet("1,000"→정수)
 *
 * 데드코드 정리(이관하지 않고 제거): popmultisel_checkCheck_paystatus / reset_multiAll_billset /
 *   check_sels_on — 전 저장소에서 호출처 0.
 *
 * 구조: 모듈 스코프 자유함수 + 얇은 브리지 클래스.
 *   - 브리지(13): onclick 문자열(전역 스코프에서 실행)·이미 이관된 모듈·서버렌더 onclick 이 호출하는 함수.
 *     multiTaxclose·getMultiMoreList 도 생성 onclick 문자열에서 호출되므로 브리지 필수.
 *   - 모듈-내부(5, 브리지 X): JS 호출로만 도달 —
 *     renderMultiBillHead/renderMultiBillBody/_multiStx1/renderMultiSelRows/make_Array_multiPleMore.
 *   - IntvalGet 은 브리지 필수: PaymentSettle(F) 가 bare 로 8회 호출한다.
 *   - 외부 전역 bare 해소: Util.formatNumber·int·swalert(import), orderTax(window),
 *     get_lastMisoo·multiPle_priceTotalGetShow(F)·get_checked_order_list(A)·get_orders(ListRender)·
 *     show_Pop_BizForm·allSetIn_new(E) — 전부 window 브리지.
 *   - 공유 상태:
 *     · multiMoreList : PopupOpener(E)와 공유 → window.multiMoreList (var 선언은 list.js 잔류로 초기화).
 *     · multiOrderList/order_onList : B 전용 → 이 모듈 스코프 var (list.js 에서 제거).
 *     · reLoadOrderNums/onList(암시적) : reset_multiAll_billset_new 쓰기 → window.* 로.
 *     · popCallmode(암시적) : 읽기 → window.popCallmode.
 *
 * 서버: POST /u/ajax/order-tax/multi-bill-list · /multi-sel-list · /reset-bill/multiple
 */
import Util from '../../../Common/Util';


// B 전용 공유 상태 (레거시 list.js var multiOrderList/order_onList 이관).
var multiOrderList = [];
var order_onList = [];

function IntvalGet(val){
    val = String(val);
    val = val.replace(/,/gi,"");
    var ret = parseInt( val );
    if( isNaN( ret )) ret = 0;
    return ret ;
}

function popmultisel_checkCheck_new(actn){
    var tot = 0;
    var sels = [];
    var obj = document.getElementById("popBizFormlist");
    var inputs = obj.getElementsByTagName("INPUT");
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].type == "checkbox"){
            if( inputs[i].checked == true){
                var eano = IntvalGet(inputs[i].getAttribute("value"));
                if( eano > 10 ){
                    sels.push(eano);
                }
            }
        }
    }
    return sels;
}

function popmultisel_checkCheck_paystatus_new(){
    var ret="";
    var selnums = [];
    var obj = document.getElementById("popBizFormlist");
    var inputs = obj.getElementsByTagName("INPUT");
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].type == "checkbox"){
            if( inputs[i].checked == true){
                var eano = IntvalGet(inputs[i].getAttribute("value"));
                var obj2 = document.getElementById("paystatusapp_"+eano);
                if(obj2 && eano > 10 ){
                    if(obj2.checked==true){
                        ret+=eano + "_on|";
                    }else{
                        ret+=eano + "_off|";
                    }
                }
            }
        }
    }
    return ret;
}

/**
 *
 * @param actn 1(다중??인듯), 2(단일?)
 * @returns {*[]}
 */
function popmultisel_checkCheck(actn){
    var cmax = 0;
    if( document.getElementById("popmultisel_eachbox_max")){
        cmax = parseInt(document.getElementById("popmultisel_eachbox_max").value);
    }
    if( isNaN(cmax)) cmax = 0;
    var tot = 0;
    var sels = [];
    for (var i = 0; i < cmax; i++ ){
        var obj = document.getElementById("popmultisel_eachbox_"+ i);
        if( obj){
            if( obj.checked==true){
                var eano = parseInt( obj.value);
                var eapp = parseInt( obj.getAttribute("data-attr") );
                sels.push(eano);
                tot = parseInt(tot + eapp);

            }
        }
    }
    if( actn == 1){
        var priceTotalmulti_tax = parseInt( tot);
        if( document.getElementById("billstatus_4").checked==true){
            priceTotalmulti_tax = parseInt( tot + ( tot * 0.1));
            document.getElementById("billPrice").value=Util.formatNumber(priceTotalmulti_tax) ;
        }
        document.getElementById("paystate_worktotal").value=Util.formatNumber(priceTotalmulti_tax) ;
        get_lastMisoo();
    }else if( actn == 2){
        return sels;
    }
}

/**
 * 세금계산서 초기화 처리 ( 다중발행된 오더에 대해서 처리 )
 * @param ordernum
 */
function reset_multiAll_billset_new(ordernum){
    var obj = document.getElementById("popBizFormlist");
    var inputs = obj.getElementsByTagName("INPUT");
    var resetNums = []; // taxnum
    var resetOrdernums = []; // ordernum
    for (var i=0; i < inputs.length ; i++ ){
        if( inputs[i].type == "checkbox"){
            var eeid = inputs[i].id;
            if( eeid.indexOf("popmultisel_eachbox_") >= 0 && inputs[i].checked == true){
                var eano = parseInt(inputs[i].getAttribute("taxnum")); if( isNaN(eano)) eano = 0;
                var eaono = parseInt(inputs[i].value); if( isNaN(eaono)) eaono = 0;
                if( eano > 1  && eaono > 1 ){
                    resetNums.push(eano);
                    resetOrdernums.push(eaono);
                }
            }
        }
    }
    if( resetOrdernums.indexOf(ordernum) < 0 ) resetOrdernums.push(ordernum);
    var mTit = "선택된 [ " + resetNums.length + "] 개 오더를 초기화 할까요?";
    Util.swalert([mTit,'question'],()=>{
        var adr = "/u/ajax/order-tax/reset-bill/multiple";
        var sendData = {"multinums": resetNums.toString() , "orderNum":ordernum , "resetOrdernums": resetOrdernums.toString() };
        $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
                window.reLoadOrderNums = resetOrdernums;
                window.onList=resetOrdernums;
                // Update_showingLists(1);
                get_orders(resetOrdernums);
                allSetIn_new(orderTax.current_ordernum,window.popCallmode);
            }});
    },['네','아니오']);
}

function multiDocumentListGet(evt, tar){
    if( evt){
        evt.preventDefault();   evt.stopImmediatePropagation();
    }
    var mg = "리스트에 선택된 항목을 불러오는중";
    var loading = "<tr><td colspan=8 style='text-align:center; height:250px; line-height:40px;'><br><img src='/img/m/pageloading_threedot.svg' style='height:20px'><br>" + mg + "</td></tr>";
    var is_relate_check = 0;

    if(document.getElementById("is_relate_check").checked == true) is_relate_check = 1;
    var bal_print_tax_refstr = document.getElementById("bal_print_tax_refstr").value;

    // 이미 다중발행된 오더(refstr 존재) 는 해당 그룹만 대상. 신규 다중발행은 체크된 목록 사용.
    // 기존엔 항상 get_checked_order_list() 를 썼더니 전체선택 상태에서 100개 초과 에러가 떴음.
    let paglistorder;
    if (bal_print_tax_refstr && bal_print_tax_refstr.length > 3) {
        paglistorder = bal_print_tax_refstr.split('|').filter(v => v).join(',');
    } else {
        paglistorder = get_checked_order_list();
    }
    if( paglistorder == undefined) paglistorder = "";
    var ch = paglistorder.split(",");
    if( ch.length > 100 ){
        Util.swalert("다중발행할 오더가 100를 넘을 수 없습니다.\n\n리스트에서 검색을 통해 다중발행할 오더만 선택해 주세요");
        return;
    }
    document.getElementById("multipleOrderListTable").style.display="table";
    document.getElementById("popBizFormlist").innerHTML = loading;
    var sendData = {"paglistorder":paglistorder , "is_relate_check":is_relate_check, "clickordernum":bal_print_tax_refstr,"baseordernum":orderTax.current_ordernum};
    var adr = "/u/ajax/order-tax/multi-bill-list";
    $.ajax({type:"POST", url:adr , data:sendData , dataType:"json", success:function(res){
            var billstatus_5 = document.getElementById("billstatus_5").checked;
            if( billstatus_5 != true){
                document.getElementById("is_relate_Div").style.display="inline-block";
            }

            // 화면표(헤더/본문/합계)는 JSON→JS 렌더. 구 인쇄표(printHtml)는 소비처가 없어 제거됨.
            document.getElementById("popBizHeadVal").innerHTML  = renderMultiBillHead(res.header);
            document.getElementById("popBizFormlist").innerHTML = renderMultiBillBody(res);

            var isSaveOktogo = res.totals.isSaveOk;
            if( isSaveOktogo != "SOK"){
                var save_bill_info_Btn = document.getElementById("save_bill_info_Btn");
                save_bill_info_Btn.style.backgroundColor="#FF0000";
                save_bill_info_Btn.style.color="#FFFFFF";
                save_bill_info_Btn.innerHTML="저장불가";
            }
            multiPle_priceTotalGetShow();
        }});
}

// 다중발행 화면표 헤더 렌더 (레거시 multiBillListHtml thead echo 대체)
function renderMultiBillHead(h){
    var s = "<TR style='height:30px; background-color:#A6A6D2;color:#FFFFFF;'>";
    s += "<th style='width:40px;color:#bdfffd' tid='체크' onclick='multi_selorderboxset(this, 1)' dataset='1' >체크</th>";
    s += "<th style='width:70px;color:#bdfffd' tid='결제' onclick='multi_selorderboxset(this, 2)' dataset='1'>결제</th>";
    s += "<th style='width:50px;' tid='작업일'>작업일</th>";
    s += "<th style='width:100px;' tid='작업자'>장비번호</th>";
    s += "<th style='width:*%;' tid='현장'>현장</th>";
    s += "<th style='width:80px;' tid='시간'>시간</th>";
    s += "<th style='width:70px;' tid='금액'>"+h.onTitle+"</th>";
    if( h.showBaljooCol ) s += "<th style='width:90px;' tid='금액' id='multiCListBaljooTh'>발주금액</th>";
    s += "<th style='width:70px;' tid='거래처'>비고</th>";
    s += "</TR>";
    return s;
}

// 다중발행 화면표 본문(행+간격행+합계행) 렌더 (레거시 showMultiLine echo + 합계 echo 대체)
function renderMultiBillBody(res){
    var t = res.totals;
    var isRelate = t.isRelate;
    var STAT1 = "text-align:center;font-weight:normal;border:none; border-bottom:1px solid #000000;border-right:1px solid #000000";
    var STAT2 = "text-align:left;border:none; border-bottom:1px solid #000000;border-right:1px solid #000000;padding-left:10px";
    var STAT3 = "text-align:center;font-weight:normal;border:none; border-bottom:1px solid #000000;border-right:0px solid #000000;border-top:1px solid #000000";
    var rows = res.rows || [];
    var html = "";
    var spacerInserted = false;
    for( var i=0; i<rows.length; i++ ){
        var r = rows[i];
        if( res.spacer.show && !spacerInserted && r.tys == 2 ){
            html += "<tr style='height:15px;'><td txtx=1 colspan='"+res.spacer.colspans+"'></td></tr>";
            spacerInserted = true;
        }
        var cb1 = "<input type='checkbox' "+r.chk+" "+r.disableset+" d1='"+r.preCnt+"' d2='"+r.tys+"' d3='"+r.chk+"' style=width:17px;height:17px;' "
                + "id='popmultisel_eachbox_"+r.n+"' taxnum='"+r.taxnum+"' value='"+r.ordernum+"'"
                + "data-attr='"+r.carPrice+"' onchange='multiPle_priceTotalGetShow()' sooPrice='"+r.sooPrice+"'  balPrice='"+r.balPrice+"'>";
        var cb2 = "<input type='checkbox' "+r.subDis+" id='paystatusapp_"+r.ordernum+"' "+r.payedCh+" style='width:16px;height:16px'>";
        html += "<tr style='height:30px;background-color:"+r.bg+"' id='trlineA_1' trtype='multiline'>";
        html += "<td txtx=24 style='text-align:center;font-weight:normal;'>"+cb1+"</td>";
        html += "<td txtx=25 style='text-align:center;font-weight:normal;'>"+cb2+" "+r.payedStr+"</td>";
        html += "<td txtx=26 style='"+STAT1+"' class='detailcforma'>"+r.edd+"</td>";
        html += "<td txtx=27 style='"+STAT1+"' class='detailcforma'>"+Util.escapeHtml(r.carplate)+"</td>";
        html += "<td txtx=28 style='"+STAT2+"' class='detailcforma'>"+Util.escapeHtml(r.address)+"</td>";
        html += "<td txtx=29 style='"+STAT2+"; text-align:center' class='detailcforma'>"+r.wtime+"</td>";
        html += "<td txtx=30 style='"+STAT1+"' class='detailcforma'>"+r.spp1+"</td>";
        if( isRelate ) html += "<td style='"+STAT1+"' class='detailcforma'>"+r.spp2+"</td>";
        var lineTxtx = isRelate ? 31 : 32;
        html += "<td txtx="+lineTxtx+" style='"+STAT3+"' class='detailcformc' makeBdx13>"+r.lineCell+"</td>";
        html += "</tr>";
    }
    // 합계행
    var label = "<div style='float:left'>";
    if( t.moreBtn ) label += "<input type='button' style='width:45px;height:25px' class='acBtn' value='추가' onclick='multiSelMore()'>&nbsp;";
    label += t.mgCont + "</div>";
    label += "<input type='hidden' id='needTo_get_Amount' value='"+t.needToGetAmount+"'>";
    label += "<input type='hidden' style='width:50px; border:none; height:20px;background-color:#D1D1E9;text-align:right' id='isSaveOktogo' value='"+t.isSaveOk+"'>";
    if( isRelate ) label += "<input type='hidden' value='"+t.relateInfo+"'>";
    if( t.relateErr ) label += "<font style='color:red'>상대방이 1명이상입니다.</font>";
    label += " 합계";
    html += "<tr style='height:30px; background-color:#D1D1E9'>";
    html += "<td txtx=4 colspan=6 style='text-align:right; padding-right:10px;font-weight:bolder'> "+label+"</td>";
    if( isRelate ){
        html += "<td txtx=5 id='multiFormTd_sprice' style='font-weight:bolder'>"+t.spriceFmt+"</td>";
        html += "<td txtx=6 id='multiFormTd_bprice' style='font-weight:bolder'>"+t.bpriceFmt+"</td>";
        html += "<td txtx=7 style='font-weight:bolder' id='multiFormTd_after' xt=1>"+t.afterText+"</td>";
    }else{
        html += "<td txtx=8 id='multiFormTd_sprice'>"+t.spriceFmt+"</td>";
        html += "<td txtx=9 id='multiFormTd_after'>"+t.afterText+"</td>";
    }
    html += "</tr>";
    return html;
}

function multiSelMore(){
    show_Pop_BizForm(orderTax.current_ordernum,window.popCallmode);
    document.getElementById("ismultiGolist").checked=true;
}

function multi_selorderboxset(tar, act){
    var obj = document.getElementById("popBizFormlist");
    var dataset = Util.int(tar.getAttribute("dataset"));
    var doAct = (dataset == 1);
    var inputs = obj.getElementsByTagName("INPUT");
    var key = (act == 1) ? "popmultisel_eachbox" : "paystatusapp";
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].type == "checkbox"){
            var eaid = inputs[i].id;
            if( eaid.indexOf(key) >= 0 ){
                if( inputs[i].disabled != true){
                    inputs[i].checked=doAct;
                }
            }
        }
    }
    var setval = (doAct == true) ? 0 : 1;
    tar.setAttribute("dataset", setval );
    multiPle_priceTotalGetShow();
}

// 다중발행 발행상태 라벨 (레거시 stx1 로직) — bal/soo 발행상태 + 묶음(★) 여부
function _multiStx1(bal, soo, isStar){
    if( bal == 0 && soo == 0 ) return "미발행";
    var s = "";
    if( bal == 1 ) s = "<font style='color:blue;font-weight:bolder'>발행</font>";
    if( soo == 1 ) s = "<font style='color:blue;font-weight:bolder'>발행</font>";
    if( bal == 2 ) s = "<font style='color:red;font-weight:bolder'>다중발행</font>";
    if( soo == 2 ) s = "<font style='color:red;font-weight:bolder'>다중발행</font>";
    if( soo == 9 ) s = "<font style='color:red;font-weight:bolder'>無발행</font>";
    if( bal == 9 ) s = "<font style='color:red;font-weight:bolder'>無발행</font>";
    if( isStar ){
        if( bal == 2 ) s = "<font style='color:red;font-weight:bolder'>★다중발행</font>";
        if( soo == 2 ) s = "<font style='color:red;font-weight:bolder'>★다중발행</font>";
        if( bal == 9 ) s = "<font style='color:red;font-weight:bolder'>★다중無</font>";
        if( soo == 9 ) s = "<font style='color:red;font-weight:bolder'>★다중無</font>";
    }
    return s;
}

// 다중발행 선택목록 렌더 (레거시 user_2000_004_pop__multi_ajax.php HTML echo 대체)
function renderMultiSelRows(data){
    var st2 = " style='text-align:center;font-size:12px;font-weight:normal;'";
    if( !data || !data.rows || (data.summary && data.summary.empty) ){
        return "<tr><td colspan=20 style='text-align:center'>선택된 오더가 없습니다.</td></tr>";
    }
    var ret = "";
    data.rows.forEach(function(r){
        var xcc = (r.xnum % 2 == 0) ? "#FFFFFF" : "#DBDBDB";
        ret += "<tr style='height:30px;background-color:" + xcc + ";' id='trlineA_" + r.xnum + "'>";
        if( r.isCancel ){
            ret += "<td" + st2 + ">취소오더</td>";
        }else{
            var chno = r.disabled ? " mydisabled='1' disabled" : "mydisabled='0'";
            var eaCh = r.checked ? " checked" : "";
            var mdd = (r.smode == 1) ? "<font style='color:red'>발주</font>" : "<font style='color:blue'>수주</font>";
            ret += "<td" + st2 + "><input type='checkbox'" + eaCh + " " + chno + " style='width:17px;height:17px;' id='popmultisel_eachbox_" + r.xnum + "' taxnum='" + r.taxnum + "' value='" + r.num + "' data-attr='" + r.carPrice + "' onchange='popmultisel_checkCheck(1)'> " + mdd + "</td>";
        }
        var ps = r.workPayed ? " checked" : "";
        var selPayst = "<input type='checkbox' id='paystatusapp_" + r.num + "'" + ps + " style='width:16px;height:16px'>결제됨";
        ret += "<td" + st2 + ">" + _multiStx1(r.balPrint, r.sooPrint, r.isStar) + "</td>"
             + "<td" + st2 + ">" + selPayst + "</td>"
             + "<td" + st2 + ">" + r.carPriceFmt + "</td>"
             + "<td" + st2 + ">" + r.workDayLabel + "</td>"
             + "<td" + st2 + ">" + Util.escapeHtml(r.workerName) + "</td>"
             + "<td" + st2 + ">" + Util.escapeHtml(r.contracter) + "</td>"
             + "<td >" + Util.escapeHtml(r.contractAddress) + "</td>"
             + "<td >" + r.multiBillPriceTotFmt + "</td>"
             + "</tr>";
    });
    var s = data.summary;
    ret += "<tr style='height:40px;'><td colspan=10 style='text-align:center'>"
         + "<input type='hidden' id='priceTotalmulti' value='" + s.priceTotal + "'>"
         + "<input type='hidden' id='popmultisel_eachbox_max' value='" + s.max + "'>"
         + "<input type='hidden' id='TXA1' value='" + s.TXA1 + "'>"
         + "<input type='hidden' id='TXA1_Str' value='" + s.TXA1_Str + "'>"
         + "<input type='hidden' id='TXA2' value='" + s.TXA2 + "'>"
         + "<input type='hidden' id='TXA2_Str' value='" + s.TXA2_Str + "'>"
         + "<div style='display:inline-block;float:left ;line-height:40px;font-weight:bolder'>총 " + s.goCnt + " 항목&nbsp;<span id='multi_checked_total_cash'>합계:" + s.TotalPFmt + "원 &nbsp;TAX:" + s.taxFmt + "원 <font style='color:red'>합계 : " + s.sstFmt + "원</font></span></div>"
         + "<div style='display:inline-block;float:right;line-height:40px'><input type='button' value='+ 오더 추가' style='width:80px; height:30px;' class='acBtn' onclick='add_multipleOrder()'></div>"
         + "</td></tr>";
    return ret;
}

function multi_sel_list_do(){
    var nums = get_checked_order_list();
    var adr = "/u/ajax/order-tax/multi-sel-list";
    var popwinOrdernum = document.getElementById("popwinOrdernum").value;
    var bal_print_tax_refstr =  document.getElementById("bal_print_tax_refstr").value;
    // popCallmode 는 이 팝업을 연 show_Pop_BizForm 이 window 에 심어둔 값이다.
    // 예전엔 서버가 세션($_SESSION['POPCallmode'])에 적어뒀다 꺼내 썼는데, 세션은 탭 구분이
    // 없어 팝업을 두 탭에 띄우면 나중 것이 앞 것을 덮었다. 요청마다 실어 보낸다 (2026-09).
    var sendData = {"selnumbers": nums,"eOrderNum": popwinOrdernum,"multi_nums":bal_print_tax_refstr , "multiMoreList":window.multiMoreList.toString(), "popCallmode": (window.popCallmode || 0)}
    $.ajax({type:"POST", url:adr, data:sendData, dataType:'json', success:function(data){
            var baseTR = document.getElementById("multibillDiv_copy").innerHTML;
            var obj = document.getElementById("multibillDiv");
            obj.innerHTML = baseTR + renderMultiSelRows(data);
            var priceTotalmulti = parseInt(document.getElementById("priceTotalmulti").value);
            var priceTotalmulti_tax = parseInt( priceTotalmulti);
            if( document.getElementById("billstatus_4").checked==true) priceTotalmulti_tax = parseInt( priceTotalmulti + ( priceTotalmulti * 0.1));
            document.getElementById("paystate_worktotal").value=Util.formatNumber(priceTotalmulti_tax) ;
            if( document.getElementById("billstatus_4").checked==true){
                var pp = parseInt(document.getElementById("billPrice").value);
                if(isNaN(pp)) pp = 0;
                if( pp == 0 ) document.getElementById("billPrice").value = Util.formatNumber(priceTotalmulti_tax) ;
            }
            var multiallcancelbtn = document.getElementById("multiallcancelbtn");
            multiallcancelbtn.disabled = false;
            multiallcancelbtn.className = "acBtn";
            multiallcancelbtn.style.color="#FF0000";
            get_lastMisoo();
        }});
}

function checkMultiChallnot(tar){
    var cc = tar.checked;
    var obj = document.getElementById("multibillDiv");
    var inputs = obj.getElementsByTagName("INPUT");
    for (var i=0; i < inputs.length ; i++ ){
        if( inputs[i].type == "checkbox"){
            var eeid = inputs[i].id;
            if( eeid.indexOf("popmultisel_eachbox_") >= 0 ){
                var isdisabled = inputs[i].getAttribute("mydisabled");
                if( isdisabled != "1") inputs[i].checked= cc; //console.log( inputs[i]);
            }
        }
    }
    popmultisel_checkCheck(1);
}

function make_Array_multiPleMore(){
    var obj = document.getElementById("multibillDiv");
    var inputs = obj.getElementsByTagName("INPUT");
    multiOrderList = [];
    order_onList = [];

    for (var i=0; i < inputs.length ; i++ ){
        if( inputs[i].type == "checkbox"){
            var eeid = inputs[i].id;
            if( eeid.indexOf("popmultisel_eachbox_") >= 0 && inputs[i].checked == true){
                var eano = parseInt(inputs[i].getAttribute("taxnum")); if( isNaN(eano)) eano = 0;
                var eaono = parseInt(inputs[i].value); if( isNaN(eaono)) eaono = 0;
                if( eaono > 1 ){
                    //var cc = inputs[i].parentNode;
                    //console.log( cc );
                    //console.log( cc.childNodes[2].innerHTML );
                    multiOrderList.push(eaono);
                }
            }
        }
    }
    var orderX = parseInt(document.getElementById("orderX").value,10);
    for (i =0 ; i < orderX ; i++ ){
        var ttar = document.getElementById("tr_order_" + i);// TODO : 오더번호로 대체
        if(ttar.style.display != "none"){
            var tar = document.getElementById("ordersel_" + i);// TODO : 오더번호로 대체
            var orderNo =parseInt( tar.value);
            if( isNaN(orderNo)) orderNo = 0;
            if( orderNo > 1 ){
                if( multiOrderList.indexOf(orderNo) < 0 ){
                    var data_attr = tar.getAttribute("data-attr");
                    var d_adrdate = tar.getAttribute("d_adrdate");
                    var d_adr = tar.getAttribute("d_adr");
                    var d_plate = tar.getAttribute("d_plate");
                    var ordType = "?";
                    if( data_attr.indexOf("|") > 0 ){
                        var cc = data_attr.split("|");
                        var cn = parseInt(cc[1]);
                        if( isNaN(cn)) cn =0 ;
                        cn == 1 ? ordType = "발주" : ordType = "수주";
                    }
                    order_onList.push({"wdate":d_adrdate , "address":d_adr, "plate":d_plate, "ordernum":orderNo , "ordType":ordType});
                }
            }

        }
    }

}

function add_multipleOrder(){
    make_Array_multiPleMore();
    //console.log( multiOrderList );
    //console.log( order_onList );
    var obj = document.getElementById("detailLists");
    var div = document.createElement('div');
    div.setAttribute("style", "width:600px; position:absolute; top:100px; left:200px;  background-color:#FFFFFF; border:2px solid #808080;-webkit-border-radius:5px;border-radius:5px;   ");
    //div.setAttribute("class", "detailInside_div");
    div.setAttribute("id", "multiTaxselecter");

    var ccbtn = "<img src='/img/closeboxcircle40.png' style='height:40px; float:right; position:relative;top:-15px;right:-10px' onclick='multiTaxclose()'>";
    var htm = "<div style='width:100%; line-height:40px; font-weight:bolder; color:#000000; text-align:center'>다중 발행에 다른오더 추가 " + ccbtn + "</div>";
    htm += "<div style='width:97%; padding:10px ; height:450px; overflow-y:auto; overflow-x:hidden;' class='detailInside_div' >";
    htm += "<table style='width:95%; margin:0px auto' id='multimoregettable' class='multimoreTable'>";
    htm += "<colgroup><col style='width:30px'/><col style='width:40px'/><col style='width:*%'/><col style='width:20%'/><col style='width:20%'/></colgroup>";
    for (var i = 0; i < order_onList.length;i++ ){
        var one = order_onList[i];
        var ordType = one.ordType;
        ordType == "발주" ? ordType = "<font style='color:red'>" + ordType : ordType = "<font style='color:blue'>" + ordType;
        htm += "<tr style='height:30px; border-bottom:1px solid #C1C1C1'>";
        htm +="		<td><input type='checkbox' style='width:20px; height;20px' value='" + one.ordernum + "'></td>";
        htm +="		<td>" + ordType + "</font></td>";
        htm +="		<td>" + Util.escapeHtml(one.address) + "</td>";
        htm +="		<td>" + one.wdate + "</td>";
        htm +="		<td>" + Util.escapeHtml(one.plate) + "</td>";
        htm +="</tr>";

    }
    htm += "</table>";
    htm += "<br><br><br>";
    htm += "</div>";
    htm += "<div style='width:100%;line-height:50px; font-weight:bolder; color:#000000; text-align:center; position:absolute; bottom:0px; background-color:#a8abb7'>";
    htm +="<input type='button' value='적용' style='width:100px; height:30px' class='acBtn' onclick='getMultiMoreList()'>&nbsp;&nbsp;";
    htm +="<input type='button' value='취소' style='width:100px; height:30px' class='acBtn' onclick='multiTaxclose()'>";
    htm +="</div>";
    div.innerHTML = htm;
    obj.appendChild(div);
}

function multiTaxclose(){
    var obj = document.getElementById("detailLists");
    var multiTaxselecter = document.getElementById("multiTaxselecter");
    obj.removeChild(multiTaxselecter);
}

function getMultiMoreList(){
    var obj = document.getElementById("multimoregettable");
    var inputs = obj.getElementsByTagName("INPUT");
    window.multiMoreList = [];
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].type=="checkbox"){
            if( inputs[i].checked == true){
                var ord = parseInt(inputs[i].value);
                if( isNaN(ord)) ord = 0;
                if( ord > 1 ){
                    window.multiMoreList.push( ord );
                }
            }
        }
    }
    console.log( window.multiMoreList );
    multiTaxclose();
    multi_sel_list_do();
}

export default class MultiIssue {
    IntvalGet = IntvalGet;
    popmultisel_checkCheck_new = popmultisel_checkCheck_new;
    popmultisel_checkCheck_paystatus_new = popmultisel_checkCheck_paystatus_new;
    popmultisel_checkCheck = popmultisel_checkCheck;
    reset_multiAll_billset_new = reset_multiAll_billset_new;
    multiDocumentListGet = multiDocumentListGet;
    multiSelMore = multiSelMore;
    multi_selorderboxset = multi_selorderboxset;
    multi_sel_list_do = multi_sel_list_do;
    checkMultiChallnot = checkMultiChallnot;
    add_multipleOrder = add_multipleOrder;
    multiTaxclose = multiTaxclose;
    getMultiMoreList = getMultiMoreList;
}
